<div class="rich-text-editor" [class.rich-text-editor--disabled]="disabled">
  <label class="rich-text-editor__label">{{ label }}</label>

  <div class="rich-text-editor__toolbar" role="toolbar" aria-label="Formatação de texto">
    <button type="button" mat-icon-button matTooltip="Negrito" (mousedown)="$event.preventDefault()"
      (click)="exec('bold')" [disabled]="disabled">
      <mat-icon>format_bold</mat-icon>
    </button>
    <button type="button" mat-icon-button matTooltip="Itálico" (mousedown)="$event.preventDefault()"
      (click)="exec('italic')" [disabled]="disabled">
      <mat-icon>format_italic</mat-icon>
    </button>
    <button type="button" mat-icon-button matTooltip="Sublinhado" (mousedown)="$event.preventDefault()"
      (click)="exec('underline')" [disabled]="disabled">
      <mat-icon>format_underlined</mat-icon>
    </button>
    <span class="rich-text-editor__divider"></span>
    <button type="button" mat-icon-button matTooltip="Lista com marcadores" (mousedown)="$event.preventDefault()"
      (click)="exec('insertUnorderedList')" [disabled]="disabled">
      <mat-icon>format_list_bulleted</mat-icon>
    </button>
    <button type="button" mat-icon-button matTooltip="Lista numerada" (mousedown)="$event.preventDefault()"
      (click)="exec('insertOrderedList')" [disabled]="disabled">
      <mat-icon>format_list_numbered</mat-icon>
    </button>
    <span class="rich-text-editor__divider"></span>
    <button type="button" mat-icon-button matTooltip="Destacar texto" (mousedown)="$event.preventDefault()"
      (click)="destacarTexto()" [disabled]="disabled">
      <mat-icon>highlight</mat-icon>
    </button>
    <button type="button" mat-icon-button matTooltip="Remover formatação" (mousedown)="$event.preventDefault()"
      (click)="exec('removeFormat')" [disabled]="disabled">
      <mat-icon>format_clear</mat-icon>
    </button>
  </div>

  <div #editor class="rich-text-editor__content" [attr.contenteditable]="!disabled"
    [attr.data-placeholder]="placeholder" [style.minHeight]="minHeight"
    (input)="onInput()" (blur)="onBlur()" (paste)="onPaste($event)">
  </div>
</div>
